import React from "react";
import { CaretLeft, CaretRight } from "phosphor-react";

// Server-side prev/next paging, shared by the batch and card lists.
const GcPagination = ({
  total,
  pageNumber,
  limit,
  prevUrl,
  nextUrl,
  onPrev,
  onNext,
  isLoading,
}) => {
  if (!total) return null;

  const pageCount = Math.max(1, Math.ceil(total / limit));
  const from = (pageNumber - 1) * limit + 1;
  const to = Math.min(pageNumber * limit, total);

  return (
    <div className="gc-pager">
      <p className="gc-pager__count">
        Showing <b>{from}</b>–<b>{to}</b> of <b>{total}</b>
      </p>
      <div className="gc-pager__nav">
        <button
          type="button"
          className="gc-pager__btn"
          aria-label="Previous page"
          disabled={!prevUrl || isLoading}
          onClick={onPrev}
        >
          <CaretLeft size={16} weight="bold" />
        </button>
        <span className="gc-pager__page">
          Page {pageNumber} of {pageCount}
        </span>
        <button
          type="button"
          className="gc-pager__btn"
          aria-label="Next page"
          disabled={!nextUrl || isLoading}
          onClick={onNext}
        >
          <CaretRight size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
};

export default GcPagination;
